import { h } from 'preact';

const CarouselArrow = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 24" {...props}>
			<path fill-rule="evenodd" d="M1.917 0L0 1.843 10.565 12 0 22.157 1.917 24 14.4 12z" />
		</svg>
	);
};

export default CarouselArrow;
